import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import './App.css';

const HomePage      = React.lazy(() => import('./pages/HomePage'));
const BikesPage     = React.lazy(() => import('./pages/BikesPage'));
const BookingPage   = React.lazy(() => import('./pages/BookingPage'));
const WhereWePage   = React.lazy(() => import('./pages/WhereWePage'));
const PrivacyPage   = React.lazy(() => import('./pages/PrivacyPage'));
const ItinerariesPage = React.lazy(() => import('./pages/ItinerariesPage'));
const TermsPage     = React.lazy(() => import('./pages/TermsPage'));
const ClientArea    = React.lazy(() => import('./pages/ClientArea'));
const ConfirmationPage = React.lazy(() => import('./pages/ConfirmationPage'));
const AdminLayout   = React.lazy(() => import('./pages/admin/AdminLayout'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div style={{minHeight:'100vh',background:'#05100a',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'3rem'}}>🚲</div>}>
        <Routes>
          <Route path="/"                   element={<HomePage />} />
          <Route path="/biciclette"         element={<BikesPage />} />
          <Route path="/prenota"            element={<BookingPage />} />
          <Route path="/dove-siamo"         element={<WhereWePage />} />
          <Route path="/privacy-policy"     element={<PrivacyPage />} />
          <Route path="/termini-condizioni" element={<TermsPage />} />
          <Route path="/itinerari" element={<ItinerariesPage />} />
          <Route path="/dashboard"          element={<ClientArea />} />
          <Route path="/prenotazione-confermata" element={<ConfirmationPage />} />
          <Route path="/prenotazione-confermata" element={<ConfirmationPage />} />
          <Route path="/admin/*"            element={<AdminLayout />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;


